import React, {useEffect, useState} from 'react';
import {motion} from 'framer-motion';
import {Calendar, Bell} from 'lucide-react';
import {getNews} from '../utils/api';

const News = () => {
    const [news, setNews] = useState([]);

    useEffect(() => {
        const fetchNews = async () => {
            try {
                const data = await getNews();
                setNews(data);
            } catch (error) {
                console.error('Error fetching news:', error);
            }
        };
        fetchNews();
    }, []);

    return (
        <div className="min-h-screen pt-24" data-testid="news-page">
            <section className="relative py-20 overflow-hidden bg-gradient-to-br from-violet-900 via-purple-800 to-blue-900 text-white">
                <div className="container mx-auto px-4 md:px-8 text-center">
                    <motion.div initial={{opacity: 0, y: 30}} animate={{opacity: 1, y: 0}} transition={{duration: 0.8}}>
                        <h1 className="font-outfit font-bold text-5xl md:text-7xl mb-6 text-white">News & Updates</h1>
                        <p className="font-dm-sans text-xl md:text-2xl max-w-3xl mx-auto text-white/95">
                            Stay informed about latest happenings at our school
                        </p>
                    </motion.div>
                </div>
            </section>

            <section className="py-24 bg-white">
                <div className="container mx-auto px-4 md:px-8">
                    <div className="max-w-4xl mx-auto space-y-10">
                        {news.map((item, index) => (
                            <motion.div
                                key={item.id}
                                className="relative overflow-hidden rounded-3xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2"
                                style={{
                                    background: 'linear-gradient(135deg, #C4122F 0%, #9F1025 100%)',
                                    marginTop: index > 0 ? '30px' : '0',
                                    marginBottom: '30px'
                                }}
                                initial={{opacity: 0, x: -50}}
                                whileInView={{opacity: 1, x: 0}}
                                transition={{delay: index * 0.1}}
                                data-testid={`news-item-${index}`}
                            >
                                {/* White Left Border Accent */}
                                <div className="absolute left-0 top-0 bottom-0 w-2 bg-white"></div>
                                
                                <div className="p-8 md:p-10 pl-10 md:pl-12">
                                    <div className="flex items-center gap-3 mb-5">
                                        <div className="p-3 bg-white/20 backdrop-blur-sm rounded-full">
                                            <Bell className="w-5 h-5 text-white" />
                                        </div>
                                        <div className="flex items-center gap-2 text-white/90">
                                            <Calendar className="w-5 h-5" />
                                            <span className="text-sm font-semibold">
                                                {new Date(item.date).toLocaleDateString('en-US', {year: 'numeric', month: 'long', day: 'numeric'})}
                                            </span>
                                        </div>
                                    </div>
                                    
                                    <h2 className="font-outfit font-bold text-3xl md:text-4xl text-white mb-5 leading-tight">
                                        {item.title}
                                    </h2>
                                    
                                    <p className="font-dm-sans text-lg md:text-xl text-white/95 leading-relaxed">
                                        {item.content}
                                    </p>
                                </div>
                                
                                {/* Hover Overlay Effect */}
                                <div className="absolute inset-0 bg-black/10 opacity-0 hover:opacity-100 transition-opacity duration-300 pointer-events-none"></div>
                            </motion.div>
                        ))}
                        
                        {news.length === 0 && (
                            <div className="text-center py-20">
                                <p className="text-slate-500 text-lg">No news updates available at the moment.</p>
                            </div>
                        )}
                    </div>
                </div>
            </section>
        </div>
    );
};

export default News;
